var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.293945H513V342.287H0V0.293945Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.127 89.508L214.818 100.868H226.76L217.098 107.888L220.79 119.247L211.127 112.226L201.464 119.247L205.155 107.888L195.491 100.868H207.435L211.127 89.508ZM117.044 197.312L121.658 211.512H136.587L124.509 220.286L129.124 234.487L117.044 225.709L104.966 234.487L109.579 220.286L97.5012 211.512H112.429L117.044 197.312ZM144.979 34.7031L149.592 48.9028H164.522L152.442 57.6779L157.057 71.8766L144.979 63.1005L132.899 71.8766L137.514 57.6779L125.436 48.9028H140.365L144.979 34.7031ZM69.6749 90.4638L74.2879 104.664H89.217L77.1385 113.439L81.7535 127.637L69.6749 118.862L57.5954 127.637L62.2104 113.439L50.1318 104.664H65.0609L69.6749 90.4638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 269.986H118.031C118.031 269.986 227.478 181.251 429.231 48.6162C429.232 48.6162 340.615 177.803 484.33 269.986ZM118.031 281.594C106.832 281.594 106.814 298.998 118.031 298.998H484.33C495.529 298.998 495.547 281.594 484.33 281.594H118.031Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.290039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/TK.d417a2b8b810d533eae259d0e4517e03.svg";
export { ForwardRef as ReactComponent };